import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Divider,
  Button,
} from "@mui/material";
import { useLocation, Link } from "react-router-dom";

const SettlementDetails = () => {
  const location = useLocation();
  const { row } = location.state || {};

  if (!row) {
    return <Typography>No settlement data provided.</Typography>;
  }

  // Safe date formatter
  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      return new Date(date).toLocaleString();
    } catch {
      return "N/A";
    }
  };

  return (
    <Card sx={{ maxWidth: "90%", margin: "auto", mt: 4, p: 2 }}>
      <CardContent>
        <Typography variant="h4" gutterBottom>
          Settlement Details
        </Typography>

        <Divider sx={{ mb: 2 }} />

        {/* Settlement Info */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography>
              <strong>Settlement ID:</strong> {row?.settlementId || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Status:</strong> {row?.settlementStatus || "N/A"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography>
              <strong>Type:</strong> {row?.type || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Reconciliation Initiated:</strong>{" "}
              {row?.reconcilationInitiated ? "Yes" : "No"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography>
              <strong>Collector App ID:</strong> {row?.collectorAppId || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Receiver App ID:</strong> {row?.receiverAppId || "N/A"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography>
              <strong>Created At:</strong> {formatDate(row?.createdAt)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Updated At:</strong> {formatDate(row?.updatedAt)}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Orders */}
        <Typography variant="h6">Orders</Typography>
        {row?.orders?.length > 0 ? (
          row.orders.map((order, index) => (
            <Box
              key={index}
              sx={{ my: 1, pl: 1, borderLeft: "2px solid #ccc" }}
            >
              <Typography>
                <strong>Order ID:</strong> {order?.id || "N/A"}
              </Typography>
              <Typography>
                <strong>Collector-Amount:</strong> ₹{order?.collector?.amount?.value || "0"}{" "}
                {order?.collector?.amount?.currency || ""}
              </Typography>
                {/* Inter-participant amount */}
                {order?.inter_participant?.amount && (
                 <Typography>
                   <strong>Inter-participant Amount:</strong>{" "}₹{order.inter_participant.amount.value}{" "}
                   {order.inter_participant.amount.currency}
                  </Typography>
                 )}
                {/* Provider amount */}
                {order?.provider?.amount && (
                <Typography>
                  <strong>Provider Amount:</strong>{" "}₹{order.provider.amount.value}{" "}
                  {order.provider.amount.currency}
                </Typography>
                )}
                {/* (Optional) Self amount */}
                {order?.self?.amount && (
                <Typography>
                  <strong>Self Amount:</strong>{" "}₹{order.self.amount.value}{" "}
                  {order.self.amount.currency}
                </Typography>
                )}
            </Box>
          ))
        ) : (
          <Typography>No orders found.</Typography>
        )}

        {/* Back button */}
        <Box sx={{ mb: 2, mt: 4 }}>
          <Button
            component={Link}
            to="/app/management/settlement"
            variant="outlined"
            color="primary"
          >
            Back
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SettlementDetails;
